export default {"src":"/_next/static/media/clams.153d24e9.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};